import { Password, LockerAliasVmid } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { LockerApiUri } from './uri';

export class PasswordApi {
  public static async getAllPasswordAliasAndVmids() {
    const res = await Http.get<LockerAliasVmid[]>(
      LockerApiUri.Password.GET_PASSWORD_ALIASES_URL
    );
    return res.data;
  }

  public static async getPasswordByVmid(vmid: string) {
    const res = await Http.get<Password>(
      LockerApiUri.Password.GET_PASSWORD_BY_VMID_URL(vmid)
    );
    return res.data;
  }

  public static async addPassword(password: Password) {
    const res = await Http.post<Password>(
      LockerApiUri.Password.PASSWORDS_BASE_URL,
      password
    );
    return res.data;
  }
}
